import ViewViewModel from "@/ViewModels/ViewViewModel";
import { IViewViewModelConstructorParameter } from "#/CoreFrameInterfaces";
import ComponentManager from "@/Management/ComponentManager";

export interface IWebComponentViewViewModelConstructorParameters extends IViewViewModelConstructorParameter {}

export default class WebComponentViewViewModel extends ViewViewModel {
    constructor(params: IWebComponentViewViewModelConstructorParameters) {
        super(params);
    }
}

ComponentManager.setViewModel('WebComponentView', WebComponentViewViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions')
